import { on } from '@ngrx/store';
import { appsActions } from '../actions';
import { IDashboardState } from '../states';

const onSetIsCheckoutAppActive = on(
  appsActions.setIsCheckoutAppActive,
  (state: IDashboardState, { isCheckoutAppActive }) => ({
    ...state,
    apps: {
      ...state.apps,
      isCheckoutAppActive,
    },
  }),
);

const onSetIsSlackWebhookActive = on(
  appsActions.setIsSlackWebhookActive,
  (state: IDashboardState, { isSlackWebhookActive }) => ({
    ...state,
    apps: {
      ...state.apps,
      isSlackWebhookActive,
    },
  }),
);

const toggleFieldsToActionHandler = {
  isSlackWebhookActive: onSetIsSlackWebhookActive,
  isCheckoutAppActive: onSetIsCheckoutAppActive,
};

const appsActionHandlersArr = [onSetIsSlackWebhookActive, onSetIsCheckoutAppActive];

export default appsActionHandlersArr;

export { toggleFieldsToActionHandler };
